enum PeriodType {
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY",
    YEARLY = "YEARLY",
    ALL_TIME = "ALL_TIME",
}

export default PeriodType;